export default {
    props: {
        instructor: Object
    },
    template: `
      <div :class="['instructor', instructor.past ? 'past' : '']">
        <div class="instructor__time">
          {{instructor.start_time.slice(0, -3)}}
          <p><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48615 0 0 4.48615 0 10C0 15.5138 4.48615 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48615 15.5138 0 10 0ZM10.7692 18.4223V17.6923C10.7692 17.2669 10.4246 16.9231 10 16.9231C9.57538 16.9231 9.23077 17.2669 9.23077 17.6923V18.4223C5.17846 18.0554 1.94462 14.8215 1.57769 10.7692H2.30769C2.73231 10.7692 3.07692 10.4254 3.07692 10C3.07692 9.57462 2.73231 9.23077 2.30769 9.23077H1.57769C1.94462 5.17846 5.17846 1.94462 9.23077 1.57769V2.30769C9.23077 2.73308 9.57538 3.07692 10 3.07692C10.4246 3.07692 10.7692 2.73308 10.7692 2.30769V1.57769C14.8215 1.94538 18.0554 5.17923 18.4223 9.23077H17.6923C17.2677 9.23077 16.9231 9.57462 16.9231 10C16.9231 10.4254 17.2677 10.7692 17.6923 10.7692H18.4223C18.0554 14.8215 14.8215 18.0554 10.7692 18.4223Z" fill="#32CC32"/>
              <path d="M10.7692 9.65932V5.38471C10.7692 4.95932 10.4246 4.61548 9.99994 4.61548C9.57533 4.61548 9.23071 4.95932 9.23071 5.38471V10.0001C9.23071 10.2447 9.35225 10.4539 9.53071 10.5939L11.7607 12.8486C11.9115 13.0009 12.1092 13.077 12.3076 13.077C12.503 13.077 12.6984 13.0024 12.8484 12.8547C13.1507 12.5555 13.153 12.0693 12.8546 11.767L10.7692 9.65932Z" fill="#32CC32"/>
              </svg>
              {{instructor.class_type.duration}} min
          </p>
        </div>
        <div class="instructor__info">
            <div>
              <img :src = "instructor.instructors[0].photo_urls.thumbnail_url">
            </div>
            <div> 
              <p class="title">{{instructor.name}}</p> 
              <p class="name">{{instructor.instructors[0].name}}</p>     
            </div>
        </div>
        <div class="instructor__btn">
          <button @click="reserveClass" class="btn" @click.prevent="reserveClass">Reserve</button>
        </div>
      </div>`,
    data() {
        return {
            selected: ''
        };
    },
    mounted() {
    },
    computed: {},
    mounted() {
    },
    methods: {
        reserveClass() {
            // GO TO STEP 2
            this.$emit('reserve', this.instructor, 2);
        }
    },
    watch: {}
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/components/instructorComponent.js